import customAxios from '../../customAxios';

import { ADMIN_PAY_PAYEMNT_ONLINE_2_COMPANY } from '../../routes';

async function payPaymentOnline2Company(factors: Array<string>) {
  try {
    return (await customAxios.post(ADMIN_PAY_PAYEMNT_ONLINE_2_COMPANY, { factors })).data;
  } catch (error: any) {
    console.error({ADMIN_PAY_PAYEMNT_ONLINE_2_COMPANY: error});
  }
}

export default payPaymentOnline2Company;
